"use client";
import React from "react";
import { createPortal } from "react-dom";

interface ThankYouModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ThankYouModal: React.FC<ThankYouModalProps> = ({ isOpen, onClose }) => {
    // Handle escape key
    React.useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = "unset";
        };
    }, [isOpen, onClose]);

    // Handle overlay click
    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    const modalContent = (
        <div
            className="modal-overlay"
            onClick={handleOverlayClick}
        >
            <div
                className="modal-container modal-sm"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="modal-header justify-content-end">
                    {/* <div className="modal-title-container">
                        <h2 className="modal-title">Thank you!</h2>
                    </div> */}
                    <button
                        type="button"
                        className="modal-close-btn"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18 6L6 18M6 6L18 18"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                {/* Modal Body */}
                <div className="modal-body pt-0">
                    <div className="thank-you-modal-content text-center">
                        <div className="thank-you-icon mb-4 d-flex justify-content-center">
                            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M35.2067 48.3067L26.8867 39.9867C26.5733 39.6756 26.19 39.5089 25.7367 39.4867C25.2833 39.4644 24.88 39.6311 24.5267 39.9867C24.1733 40.3422 23.9956 40.7356 23.9933 41.1667C23.9911 41.5978 24.1689 41.9911 24.5267 42.3467L33.32 51.14C33.8578 51.68 34.4856 51.95 35.2033 51.95C35.9211 51.95 36.55 51.68 37.09 51.14L55.3467 32.8867C55.6578 32.5733 55.8244 32.19 55.8467 31.7367C55.8689 31.2833 55.7022 30.88 55.3467 30.5267C54.9911 30.1733 54.5978 29.9956 54.1667 29.9933C53.7356 29.9911 53.3422 30.1689 52.9867 30.5267L35.2067 48.3067ZM40.01 70C35.8633 70 31.9633 69.2133 28.31 67.64C24.6589 66.0644 21.4822 63.9267 18.78 61.2267C16.0778 58.5267 13.9389 55.3533 12.3633 51.7067C10.7878 48.06 10 44.1611 10 40.01C10 35.8589 10.7878 31.9589 12.3633 28.31C13.9367 24.6589 16.0711 21.4822 18.7667 18.78C21.4622 16.0778 24.6367 13.9389 28.29 12.3633C31.9433 10.7878 35.8433 10 39.99 10C44.1367 10 48.0367 10.7878 51.69 12.3633C55.3411 13.9367 58.5178 16.0722 61.22 18.77C63.9222 21.4678 66.0611 24.6422 67.6367 28.2933C69.2122 31.9444 70 35.8433 70 39.99C70 44.1367 69.2133 48.0367 67.64 51.69C66.0667 55.3433 63.9289 58.52 61.2267 61.22C58.5244 63.92 55.3511 66.0589 51.7067 67.6367C48.0622 69.2144 44.1633 70.0022 40.01 70ZM40 66.6667C47.4444 66.6667 53.75 64.0833 58.9167 58.9167C64.0833 53.75 66.6667 47.4444 66.6667 40C66.6667 32.5556 64.0833 26.25 58.9167 21.0833C53.75 15.9167 47.4444 13.3333 40 13.3333C32.5556 13.3333 26.25 15.9167 21.0833 21.0833C15.9167 26.25 13.3333 32.5556 13.3333 40C13.3333 47.4444 15.9167 53.75 21.0833 58.9167C26.25 64.0833 32.5556 66.6667 40 66.6667Z" fill="#31A24C" />
                            </svg>
                        </div>
                        <h3 className="thank-you-title">Thank you!</h3>
                        <p className="thank-you-message">
                            We appreciate your interest in our agency. Let&apos;s create something amazing together reach out anytime.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    // Render modal using portal
    return createPortal(modalContent, document.body);
};

export default ThankYouModal;

